import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "cy-notice-id title" };
const _hoisted_4 = { class: "option-ctrl-area" };
const _hoisted_5 = ["title"];
const _hoisted_6 = { class: "text-body wh-pl" };
import { onMounted, onUnmounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
import CardSection from '@/components/Common/CardSection.vue';
import { storeToRefs } from 'pinia';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { isTodayTextColor, formatDate, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { autoLcBarogoNotice } from '@/locales/ko/views/barogo_notice';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // Page: 바로고 공지사항 상세 조회
        const route = useRoute();
        const router = useRouter();
        const pBarogoNotice = pStore.piniaBarogoNotice;
        const { itemDetail } = storeToRefs(pBarogoNotice);
        const itemId = route.params.barogoNoticeId;
        const lc = autoLcBarogoNotice();
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = () => {
            router.push({
                name: routeName.BAROGO_NOTICE,
            }).catch(() => { });
        };
        onMounted(async () => {
            try {
                await pBarogoNotice.getItem(itemId);
            }
            catch (error) {
                console.log('e', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        });
        onUnmounted(() => {
            pBarogoNotice.clear();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(itemDetail).title), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["cy-created-at item body2-text", _unref(isTodayTextColor)(_unref(itemDetail).createdAt)]),
                                    title: _unref(lc)('list.table.created_time')
                                }, _toDisplayString(_unref(formatDate)(_unref(itemDetail).createdAt, _unref(dateFormatType).FULL_DATE)), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(itemDetail).body), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(BoardFooter, null, {
                    left: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
